import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import {
  groupContentFields,
  groupERGcategories,
  groupPrivacyStatusDesc,
  profilePicValidityCheck,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  groupRolePriviledge,
} from "../../../utils/constants";
import moment from "moment";
import { Modal, ModalBody, Button } from "reactstrap";
import StoriesContainer from "../SingleGroupStories.jsx";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";

class GroupStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      privacy: null,
      description: "",
      members: [],
      storyType: null,
      showCreateStoryModal: false,
      topics: [],
      menu: "",
    };
  }

  componentDidMount() {
    this.props.highlightMenu("S");
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  getTopics = () => {
    if (!this.props.user) return;
    let orgId = this.props.user.profile.organizationId._id;

    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };

  toggleCreateStory = (e) => {
    // console.log(e)
    this.setState({ showCreateStoryModal: true, storyType: "Create Story" });
  };

  closeModal = () => {
    this.setState({ showCreateStoryModal: false });
  };

  onStoryPublish(story) {
    let { stories } = this.state;
    stories = [story, ...stories];
    this.setState((prevState) => ({
      stories,
      totalStories: prevState.totalStories + 1,
      originalStoryTotal: prevState.originalStoryTotal + 1,
      showCreateStoryModal: false,
    }));
  }

  goToSettings = (val) => {
    this.props.goToSettings(val);
  };

  render() {
    let {
      name,
      privacy,
      description,
      invitedUsers,
      memberCount,
      members,
      user,
      group,
      menu,
      topics,
      currentRole,
      storyType,
    } = this.props;

    let { showCreateStoryModal } = this.state;

    let privacy_status = null;
    if (privacy) {
      privacy_status =
        privacy == "ENTERPRISE"
          ? "Open"
          : privacy == "PRIVATE"
          ? "Private"
          : privacy;
    }
    let profilePic =
      this.props.user.profile && profilePicValidityCheck(this.props.user.profile.profilePic)
        ? this.props.user.profile.profilePic
        : false;
    let user_name = `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`;

    return (
      <span className="grp_single_page_stories_container">
        <div className="grp_single_page_details_post_container">
          <div
            className={`rounded-lg grp_single_page_post_item ${
              groupRolePriviledge({
                role: currentRole,
                action: 0,
                group,
                role_priv: [0, 1, 2, 1000],
              })
                ? ""
                : "group_role_disabled"
            }`}
            onClick={
              groupRolePriviledge({
                role: currentRole,
                group,
                action: 0,
                role_priv: [0, 1, 2, 1000],
              })
                ? () => this.toggleCreateStory()
                : null
            }
          >
            <div className="flex justify-between">
              {profilePic != false ? (
                <img src={profilePic} style={{objectFit:"cover"}} />
              ) : (
                <span
                  data-letters={this.getInitials(this.props.user.profile)}
                ></span>
              )}
              {/* <img src="https://raw.githubusercontent.com/shibbirweb/public-asset/master/shibbir.jpg" alt="MD. Shibbir Ahmed"/> */}
              <input
                className="flex-1 px-4 outline-none"
                placeholder={`What's on your mind, ${user_name}`}
                readOnly
              />
            </div>
            <div className="text-gray-400 text-sm font-semibold flex grp_single_page_post_options_container">
              {/* <div className="grp_single_page_post_options_item flex flex-1 justify-center items-center cursor-pointer hover:bg-gray-800 rounded-lg">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                                      </svg>
                                      <span className="grp_single_page_post_options_container_text">Live Video</span>
                                  </div> */}

              <div className="grp_single_page_post_options_item flex flex-1 justify-center items-center cursor-pointer hover:bg-gray-800 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-green-500 mr-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                  />
                </svg>
                <span className="grp_single_page_post_options_container_text">
                  Photo/Video
                </span>
              </div>

              <div className="grp_single_page_post_options_item flex flex-1 justify-center cursor-pointer items-center hover:bg-gray-800 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-yellow-500 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="grp_single_page_post_options_container_text">
                  Feeling/Activity
                </span>
              </div>
            </div>
          </div>

          {group && group._id ? (
            <StoriesContainer
              currentRole={currentRole}
              closeModal={this.closeModal}
              showCreateStoryModal={showCreateStoryModal}
              group={group}
              currentGroupJoinedAnounymously={
                this.props.currentGroupJoinedAnounymously
              }
            />
          ) : null}
        </div>
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupStories, axios)));
